import { Modal } from "antd";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import ReactPDF from "@react-pdf/renderer";
import blanco from "../../assets/images/blanco.png";
import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { apiUrl } from "../../common/config/Environments";
import { useHistory } from 'react-router-dom';

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EquipmentActions } from "../../services/Equipment/EquipmentSlice";
import { PdfComputersEquipment } from "../PdfComputersEquipment/PdfComputersEquipment";
import { PdfNetworkingAndCommunicationsEquipment } from "../PdfNetworkingAndCommunicationsEquipment/PdfNetworkingAndCommunicationsEquipment";
import { PdfPeripheralsAndAccessoriesEquipment } from "../PdfPeripheralsAndAccessoriesEquipment/PdfPeripheralsAndAccessoriesEquipment";
import { PdfComputersReportComponent } from "../PdfComputersReportComponent/PdfComputersReportComponent";

export const EquipmentSystem = ({
  data,
  setEdit,
  setEquipData,
  width,
  height,
  extraOnClick,
}) => {
  const [visibleModal, setVisibleModal] = useState(false);
  const { enterpriseImage } = useSelector((state) => state.Enterprise);
  const [pdf, setPdf] = useState(false);
  const {
    equipAndReportPDF,
    fullDataEquipment,
    loadingFullDataEquipment,
    loadingPartsComputersEquipment,
    partsComputersEquipment,
  } = useSelector((state) => state.Equipment);
  const [image, setImage] = useState(false);
  const { roleUser, fullUser, idUser } = useSelector((state) => state.Login);
  const history = useHistory()

  const dispatch = useDispatch();
  let equipmentType;

  if (data.networkingAndCommunicationsEquipment) {
    equipmentType = "networkingAndCommunicationsEquipment";
  } else if (data.peripheralsAndAccessoriesEquipment) {
    equipmentType = "peripheralsAndAccessoriesEquipment";
  } else if (data.computersEquipment) {
    equipmentType = "computersEquipment";
  }
  useEffect(() => {
    fetch(`${apiUrl}/${equipmentType}/imageById?id=${data.id}`)
      .then((response) => response.json())
      .then((data) => setImage(data))
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    pdf === "all" && dispatch(EquipmentActions.getEquipAndReportPDF(data.id));
  }, [pdf]);

  const ModalEquip = () => {
    const [content, setContent] = useState(false);
    const onClickEdit = () => {
      setEdit(true);
      setEquipData(data);
    };

    useEffect(() => {
      if (fullDataEquipment) {
        switch (equipmentType) {
          case "networkingAndCommunicationsEquipment":
            setContent(
              <PdfNetworkingAndCommunicationsEquipment
                fullDataEquipment={fullDataEquipment}
                enterprise={enterpriseImage}
              />
            );
            break;
          case "peripheralsAndAccessoriesEquipment":
            setContent(
              <PdfPeripheralsAndAccessoriesEquipment
                fullDataEquipment={fullDataEquipment}
                enterprise={enterpriseImage}
              />
            );
            break;
          case "computersEquipment":
            setContent(
              <PdfComputersEquipment
                fullDataEquipment={fullDataEquipment}
                enterprise={enterpriseImage}
              />
            );
            break;
        }
      }
      if (partsComputersEquipment) {
        switch (equipmentType) {
          case "networkingAndCommunicationsEquipment":
            setContent(
              <PdfNetworkingAndCommunicationsEquipment
                fullDataEquipment={fullDataEquipment}
                enterprise={enterpriseImage}
              />
            );
            break;
          case "peripheralsAndAccessoriesEquipment":
            setContent(
              <PdfPeripheralsAndAccessoriesEquipment
                fullDataEquipment={fullDataEquipment}
                enterprise={enterpriseImage}
              />
            );
            break;
          case "computersEquipment":
            setContent(
              <PdfComputersReportComponent
                fullDataEquipment={partsComputersEquipment}
                enterprise={enterpriseImage}
              />
            );
            break;
        }
      }
    }, [fullDataEquipment, partsComputersEquipment]);

    return (
      <Modal
        className="ModalEquip"
        width={fullDataEquipment || partsComputersEquipment ? "90vw" : "38vw"}
        visible={visibleModal}
        footer={null}
        onCancel={() => {
          setVisibleModal(false);
          dispatch(EquipmentActions.setFullDataEquipment(false));
          dispatch(EquipmentActions.setPartsComputersEquipment(false));
          dispatch(EquipmentActions.setEquipAndReportPDF(false));
        }}
      >
        {!fullDataEquipment && <p className="title">{data.name}</p>}
        {!fullDataEquipment && !partsComputersEquipment && (
          <div className="div">
            <button
              className="button"
              onClick={() => {
                switch (equipmentType) {
                  case "networkingAndCommunicationsEquipment":
                    dispatch(
                      EquipmentActions.getFullDataNetworkingAndCommunicationsEquipment(
                        data.id
                      )
                    );
                    break;
                  case "peripheralsAndAccessoriesEquipment":
                    dispatch(
                      EquipmentActions.getFullDataPeripheralsAndAccessoriesEquipment(
                        data.id
                      )
                    );
                    break;
                  case "computersEquipment":
                    dispatch(
                      EquipmentActions.getFullDataComputersEquipment({
                        id: data.id,
                        parts: "false",
                      })
                    );
                    break;
                }
              }}
            >
              {loadingFullDataEquipment ? (
                <LoadingOutlined />
              ) : (
                "Ver Hoja de Vida"
              )}
            </button>
            {equipmentType === "computersEquipment" && (
              <button
                className="button"
                onClick={() => {
                  switch (equipmentType) {
                    case "networkingAndCommunicationsEquipment":
                      dispatch(
                        EquipmentActions.getFullDataNetworkingAndCommunicationsEquipment(
                          data.id
                        )
                      );
                      break;
                    case "peripheralsAndAccessoriesEquipment":
                      dispatch(
                        EquipmentActions.getFullDataPeripheralsAndAccessoriesEquipment(
                          data.id
                        )
                      );
                      break;
                    case "computersEquipment":
                      dispatch(
                        EquipmentActions.getPartsComputersEquipment({
                          id: data.id,
                        })
                      );
                      break;
                  }
                }}
              >
                {loadingPartsComputersEquipment ? (
                  <LoadingOutlined />
                ) : (
                  "Ver partes remplazadas"
                )}
              </button>
            )}
            {fullUser.canCreate && (equipmentType === 'computersEquipment' || equipmentType === 'peripheralsAndAccessoriesEquipment') && (
              <button
                className="button"
                onClick={() => {
                  onClickEdit(true);
                  switch (equipmentType) {
                    case "networkingAndCommunicationsEquipment":
                      dispatch(
                        EquipmentActions.getFullDataNetworkingAndCommunicationsEquipment(
                          data.id
                        )
                      );
                      break;
                    case "peripheralsAndAccessoriesEquipment":
                      dispatch(
                        EquipmentActions.getFullDataPeripheralsAndAccessoriesEquipment(
                          data.id
                        )
                      );
                      break;
                    case "computersEquipment":
                      dispatch(
                        EquipmentActions.getFullDataComputersEquipment({
                          id: data.id,
                          parts: "false",
                        })
                      );
                      break;
                  }
                }}
              >
                {loadingFullDataEquipment ? (
                  <LoadingOutlined />
                ) : (
                  "Editar Hoja de Vida"
                )}
              </button>
            )}
            {fullUser.canCreate && roleUser.id == 37 &&
              <button className='button' onClick={() => {
                history.push('/Traslados', { equipSelectedToTransfer: data })
              }}>
                {loadingFullDataEquipment ? <LoadingOutlined /> : "Trasladar"}
              </button>}
            {fullUser.canCreate && roleUser.id == 3 &&
              <button className='button' onClick={() => {
                history.push('/Traslados', { equipSelectedToTransfer: data, agent: true })
              }}>
                {loadingFullDataEquipment ? <LoadingOutlined /> : "Solicitar Traslado"}
              </button>}
            {/* <button className='button' onClick={() => {
                            dispatch(EquipmentActions.setFullDataEquipment(
                                {
                                    "id": 863,
                                    "idM": null,
                                    "licensePlate": "",
                                    "dbState": true,
                                    "state": " ",
                                    "createdDate": null,
                                    "sectorCode": null,
                                    "nit": null,
                                    "number": null,
                                    "name": " ",
                                    "computersEquipment": {
                                        "id": 164,
                                        "equipType": " ",
                                        "SO": " ",
                                        "version": " ",
                                        "processors": [],
                                        "startWarranty": null,
                                        "endWarranty": null,
                                        "ipAddress": " ",
                                        "macAddress": " ",
                                        "observations": null,
                                        "image": null,
                                        "adquisitionWay": " ",
                                        "supplier": ".",
                                        "supplierPhone": ".",
                                        "brandLaptop": null,
                                        "modellLaptop": null,
                                        "serieLaptop": null,
                                        "licensePlateLaptop": null,
                                        "photoLaptop": null,
                                        "photoLaptopSerial": null,
                                        "statusLaptop": null,
                                        "validityLaptop": null,
                                        "lastMttoLaptop": null,
                                        "noveltyLaptop": null,
                                        "brandAllInOne": " ",
                                        "modellAllInOne": " ",
                                        "serieAllInOne": " ",
                                        "licensePlateAllInOne": " ",
                                        "photoAllInOne": null,
                                        "photoAllInOneSerial": null,
                                         "statusAllInOne": " ",
                                        "validityAllInOne": null,
                                        "lastMttoAllInOne": null,
                                        "noveltyAllInOne": "",
                                        "brandCPU": null,
                                        "modellCPU": null,
                                        "serieCPU": null,
                                        "licensePlateCPU": null,
                                        "photoCPU": null,
                                        "photoCPUSerial": null,
                                        "statusCPU": null,
                                        "validityCPU": null,
                                        "lastMttoCPU": null,
                                        "noveltyCPU": null,
                                        "brandMonitor": null,
                                        "modellMonitor": null,
                                        "serieMonitor": null,
                                        "licensePlateMonitor": null,
                                        "photoMonitor": null,
                                        "photoMonitorSerial": null,
                                        "statusMonitor": null,
                                        "validityMonitor": null,
                                        "lastMttoMonitor": null,
                                        "noveltyMonitor": null,
                                        "brandKeyboard": " ",
                                        "modellKeyboard": " ",
                                        "serieKeyboard": " ",
                                        "licensePlateKeyboard": " ",
                                        "photoKeyboard": null,
                                        "photoKeyboardSerial": null,
                                        "statusKeyboard": " ",
                                        "validityKeyboard": null,
                                        "lastMttoKeyboard": null,
                                        "noveltyKeyboard": "",
                                        "brandMouse": " ",
                                        "modellMouse": " ",
                                        "serieMouse": " ",
                                        "licensePlateMouse": " ",
                                        "photoMouse": null,
                                        "photoMouseSerial": null,
                                        "statusMouse": " ",
                                        "validityMouse": null,
                                        "lastMttoMouse": null,
                                        "noveltyMouse": "",
                                        "brandSignaturePad": null,
                                        "modellSignaturePad": "",
                                        "serieSignaturePad": "",
                                        "licensePlateSignaturePad": "",
                                        "photoSignaturePad": "{}",
                                        "photoSignaturePadSerial": "{}",
                                        "statusSignaturePad": null,
                                        "validitySignaturePad": null,
                                        "lastMttoSignaturePad": null,
                                        "noveltySignaturePad": "",
                                        "brandWebcam": null,
                                        "modellWebcam": "",
                                        "serieWebcam": "",
                                        "licensePlateWebcam": "",
                                        "photoWebcam": "{}",
                                        "photoWebcamSerial": "{}",
                                        "statusWebcam": null,
                                        "validityWebcam": null,
                                        "lastMttoWebcam": null,
                                        "noveltyWebcam": "",
                                        "brandBardcodeReader": null,
                                        "modellBardcodeReader": "",
                                        "serieBardcodeReader": "",
                                        "licensePlateBardcodeReader": "",
                                        "photoBardcodeReader": "{}",
                                        "photoBardcodeReaderSerial": "{}",
                                        "statusBardcodeReader": null,
                                        "validityBardcodeReader": null,
                                        "lastMttoBardcodeReader": null,
                                        "noveltyBardcodeReader": "",
                                        "brandPowerAdapter": " ",
                                        "modellPowerAdapter": " ",
                                        "seriePowerAdapter": " ",
                                        "licensePlatePowerAdapter": " ",
                                        "photoPowerAdapter": '{}',
                                        "photoPowerAdapterSerial": '{}',
                                        "statusPowerAdapter": " ",
                                        "validityPowerAdapter": null,
                                        "lastMttoPowerAdapter": null,
                                        "noveltyPowerAdapter": "",
                                        "brandFingerprintReader": null,
                                        "modellFingerprintReader": "",
                                        "serieFingerprintReader": "",
                                        "licensePlateFingerprintReader": "",
                                        "photoFingerprintReader": "{}",
                                        "photoFingerprintReaderSerial": "{}",
                                        "statusFingerprintReader": null,
                                        "validityFingerprintReader": null,
                                        "lastMttoFingerprintReader": null,
                                        "noveltyFingerprintReader": "",
                                        "brandDiadems": null,
                                        "modellDiadems": "",
                                        "serieDiadems": "",
                                        "licensePlateDiadems": "",
                                        "photoDiadems": "{}",
                                        "photoDiademsSerial": "{}",
                                        "statusDiadems": null,
                                        "validityDiadems": null,
                                        "lastMttoDiadems": null,
                                        "noveltyDiadems": "",
                                        "brandSource": null,
                                        "modellSource": "",
                                        "serieSource": "",
                                        "licensePlateSource": "",
                                        "photoSource": "{}",
                                        "photoSourceSerial": "{}",
                                        "statusSource": null,
                                        "validitySource": null,
                                        "lastMttoSource": null,
                                        "noveltySource": "",
                                        "diskComputer": [
                                            {
                                                "id": 158,
                                                "type": " ",
                                                "capacity": " ",
                                                "brand": " ",
                                                "serie": " ",
                                                "status": " "
                                            }
                                        ],
                                        "ramComputer": [
                                            {
                                                "id": 177,
                                                "type": " ",
                                                "capacity": " ",
                                                "brand": " ",
                                                "serie": " ",
                                                "status": " "
                                            }
                                        ]
                                    },
                                    "dependency": {
                                        "id": 983,
                                        "name": " ",
                                        "email": " ",
                                        "dependencyUser": [
                                            {
                                                "id": 303,
                                                "status": " ",
                                                "dateAssignment": "2023-01-01T17:34:27.000Z",
                                                "user": {
                                                    "id": 222,
                                                    "profesion": " ",
                                                    "position": " ",
                                                    "email": " ",
                                                    "dbState": true,
                                                    "canCreate": true,
                                                    "password": "41930862",
                                                    "person": {
                                                        "id": 148,
                                                        "name": " ",
                                                        "secondName": " ",
                                                        "lastName": " ",
                                                        "secondLastName": " ",
                                                        "cardId": " ",
                                                        "phone": " ",
                                                        "firm": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAeAB4AAD/4RD0RXhpZgAATU0AKgAAAAgABAE7AAIAAAAOAAAISodpAAQAAAABAAAIWJydAAEAAAAcAAAQ0OocAAcAAAgMAAAAPgAAAAAc6gAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAExFT05FTCBUT1JSRVMAAAWQAwACAAAAFAAAEKaQBAACAAAAFAAAELqSkQACAAAAAzE3AACSkgACAAAAAzE3AADqHAAHAAAIDAAACJoAAAAAHOoAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAyMDIzOjA2OjI2IDEyOjIyOjU0ADIwMjM6MDY6MjYgMTI6MjI6NTQAAABMAEUATwBOAEUATAAgAFQATwBSAFIARQBTAAAA/+ELIGh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8APD94cGFja2V0IGJlZ2luPSfvu78nIGlkPSdXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQnPz4NCjx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iPjxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+PHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9InV1aWQ6ZmFmNWJkZDUtYmEzZC0xMWRhLWFkMzEtZDMzZDc1MTgyZjFiIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iLz48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyI+PHhtcDpDcmVhdGVEYXRlPjIwMjMtMDYtMjZUMTI6MjI6NTQuMTY2PC94bXA6Q3JlYXRlRGF0ZT48L3JkZjpEZXNjcmlwdGlvbj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyI+PGRjOmNyZWF0b3I+PHJkZjpTZXEgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOmxpPkxFT05FTCBUT1JSRVM8L3JkZjpsaT48L3JkZjpTZXE+DQoJCQk8L2RjOmNyZWF0b3I+PC9yZGY6RGVzY3JpcHRpb24+PC9yZGY6UkRGPjwveDp4bXBtZXRhPg0KICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8P3hwYWNrZXQgZW5kPSd3Jz8+/9sAQwAHBQUGBQQHBgUGCAcHCAoRCwoJCQoVDxAMERgVGhkYFRgXGx4nIRsdJR0XGCIuIiUoKSssKxogLzMvKjInKisq/9sAQwEHCAgKCQoUCwsUKhwYHCoqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioq/8AAEQgAYACsAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A+kaKKKACiiigAooooAKKKKACioLy8ttPtHub2eOCGMZaSRsAV5/d+NPEnimY2vw+0vFqW2tq96CsS9sqvBbHX3oA76+1Gz0y3M9/cxW0SjJeVworg9W+OPg3TSVgup9QZW2kWcDSDP1ApbT4TxajJFdeONVuteuo23BHfZCD14UY4+tdnp+gaRpduINO021gjHZIhQB55b/tBeE5JALmLULNScb5rRgK9E0rXdM1y387SbyK6TAOY2Bxn1Happ9MsLqMx3FlbyoRgq8QI/lXl3jrwbdeEbweNfAMYgmsVL3+nIMR3EXViB64BoA9bzRWX4b1uDxJ4asNYtM+TeQiRQeo9R+YrUoAKKKKACiiigAooooABRRQTigAopM5FITg80AOoPSm7uuOaxPEvi7S/CenC61ebazsEigQbpJnPAVV6nJ4oA2ywVSWIAHcmuG1X4lwyXsmleDrRte1RcqVhOIoj/tv0HPWqU2j+I/iDIJNZuJdD8PyAFbGI4uJx/tn+EH8+a7TRfD2leG9NWy0ezjtogOdg5c+pPU0AeIfF2w8TaT4Ri1fWtR+3avdXSxwWcCnyLdRliAM8njqa9Y+GOvHxJ8ONI1JlRJJIArqi7VDDg4FYvj3y9R+IHg3SJAHWaWeZlIyMLHj+tN+B0P2L4dvZHraahcx8+gkOKAPRz0rG8WSX8fgzWX0dzHfpZTNbMOSJNh2n65qDxlr03h3wTqms2sQmms7dpURjwTXnut/Fq5tNH8A62scY0zWp2TUsDcEBAXHtySeaAN34UfEK38UeArO41fUIRqsIaK7WRgjblPXB9qZ4w8ex6pZ3fhjwbG2razeQmEtbjdFbBxtLu/TjOce1cr4C8A+F7zWPFtncaX9vaz1MmOZXIV1ddwHBxXYalrll8Pr/wAPaNpui21udb1BbUR25wwU8M5HUgZFAHTeENAXwp4N0zQ1k837FAIy/wDebkk/nmtrfxQQeo646U3II54xQApkwe1OVty5FVpG2JI6fOyoWC+vFcT8HPF+p+NfB9zqWsiMTR38sChBgbVxj+dAHV+IvEmmeFdIfUdauBBApwOMs7dlA7muY8FfFO08aeI7vSItMu7CaC3FyhuVx5kZOAcVv+JPC1j4ludMfUk8yPT7j7QsZ+6zAcZHtXjnh34k6aPG/iXxElrPe61eTppWmaRaoS4ii4BY4woZu/agD3/cN+3IzjOKWuG8GaL4mn1u48SeMrhY7iZPLttPhb5LePrz6t713NABTSvPU06igBMcHFJwFJYjA70yWeOCF5ZnVERSzMxwAPU15vcXuu/EzUmtNFaXSfDELlZ777st76rHnoOozg0AW/EPxBnudQOgeA7b+1NWclWnH+otj3Lt0OPSrXhX4dw6dfHXPE1wdY16Rg5uJjlID/djXoMevWuj8P8AhrS/DGmpY6NaJbxDlsdXbuxPcmtCeaK3jMkzhQo7/wCFABI6orM7BFX7zMcAfU1nf8JFpr6pb6cl7C13cRmWOJWySgxk15r8SNVvNe+ImheChdGw0m+haeecNtNxj/lmD79Mdeaf4b8P6Y3xo1y8Mypb6Lp8Fhbw7sdRudupPUY/GmBd8TX1vH8ePCbMwZY9PvCNvODgVjyeL7r4c+HdKU2SIde1yQKZm5jjdz82B7EGuP8Ai/8AFCLSvHml/wDCF+VJeacksMk5TKFmxkfgas+KNR1V/EvgvSviCtrc+b5skcsI2qN6AR5/2twAFAjb0rVta8Zav8R/CGuXTPLEkn2KFhgBOduB78VS8LaJbeIf2UtQ0+4VBcWKXDKXGTFJE27j0zt/Wt/xTo2on4uaLq/g2SCPVtQ06RLwy/dWLtIQOpHYd8U/V/hz4e8H+HL66n8T32j2F1AU1EK4ZLktndhSPvHJHFIDc+HthongD4U2+qS3LLDcWyX15dXDZZmZASPfHQCqPgfTbrxr4ub4h+ILVreNYzb6LZyjmKLJzKfdvXjiq+i6BefEA6bPqVtNp3hPTURbHTpuJLvYAFeTtt4BxgV6Jquv6H4atFfV9QtNPiRQFEsgXgdAB1oGajDKnNcl4g8SLB4g0/w5p19BDe3gkeVmIJhjVQSTz154p/iHx3pWneCf7b0+/gnF5GV04qci4kPChR35rxi98C3UfjSS4uLqfVdY8SaRNcWMzZTypYwrPGR6Y4FAHp/wu1rVdXm8RRanc/bLWyvzb2t15YUSrjn615Vp/iHW/AOt6z8Pre7t9IjS7nvotTnU4aIpuAHbccCk0TxbqfhLw54dt7K/m/tqO+8m70RrYjerPgnOOTjvmvoe80PStYVJNT0y3uHKj/XRBmHtmgDB+Fetar4h+HOm6nrw/wBLmVstt271BwGx710trpOnWUzzWVjbW8shy7xQqrMfcgVYhhjt4UigRY40AVUUYCj0FPoAKKKKACiiigDyrV9Sm8b/ABTuvCL3f2HRtHjSa+XcFa8ZuQg/2R3rupte0TRbaO2juIgsahUhg+ZuOgwKpeIfh54Z8S6kuoatYbrxQB58UjRswHYkHmtPSPDekaJCsemWUcWP4j8zfmeaAI4L7UNUhiltLc2sL9WnGGx6gVctdNityXkZp5WOS8hz+VXaKAMPxJ4M0Dxdaxwa/p0d0sJzE2SjRn2ZSCK82l+Fkvw+8bW3ifwPYS6natE0V7p8twS7EnIdSepHoa9looA+RviFoOux6g2op4duLGyu9RmFvE4XzN8oH/swGP616HpN7e+LtGudN8Z+Eb2PUGtYrOxHk42sB/rN/wDDg4Oe2K7n4x25/wCEAk1GPAk0q5hvRx2RwSPypbT4ir4iu1sPBsH9oS+Ss0122RDACOmT95s9hQBT0mw0j4Z2kS3l3cax4huoVhjVm3SyKv3Y1HZR6mltvDP2y6Xxb8TpYfNtW8y1snb9xZLxgkd2z3qL4bXVlfeE77xdNG13rAacXEkhyQ0eflT+6OK4v4ta6/jf9n+z8VWcMkAaZUnjD/dUyBTn/gSj86AOy8a+PNfttVnsfBFra3a6bYLqF28nzb4z0VMEckA1z/iI6DrvgQeN9F8NjVPEOvQrZQ7lMwt5GBUnaSQoBya6zRdEvbZ9K17QIbe5t77S7e2vIJW25VU4ZTj35znNcp4B03xLo2oeNvCGjXNrBNa30E8EsgLJbRzqzNtHcgAEe9AEWm+Gri81rStC0dIY7/wZaI+Lgb4JpZBkqcdCD+Vd/wCHPCmrnxM/iXxheW9zqSwG3tYbVSIraMkFsZ53HAya2PDHhm28Nae8UTtPdXD+bd3Un355D1Y1t0ARNawPOszwRtKv3ZCgLD8aloooAKKKKACiiigAzRRSZoACM9aTOOlBz3pDTAUHmnU3pS5pALXMeLfHmk+EYlS7dri+mO23srcb5ZSenA6c0zW/Ek1xqj+HvDZWXVNgaaTqtohyNze/oKd4c8C6boVw1/Nm/wBVkOZL64+Z+ew9BQBzC6F4o+INnqC+LgNL0e6iZbfTI2/etkcM7due2Kf8GZo38DWFpHHsl08zadcbRj50bIz74NelbcElcAnrx1rzbwiI9D+Kni7w4D5a3Tw6vbKPR8LJj8RQBz3g/U5fA1vrvgvUdG1Ce5lvJ5LSSGEsk8cnQlug60vw+8OXGtfAbX/B2oQ+VfRTXVsYW4KOTvjJ/Ej8q9p2AsGIG7GAcdKgt9PtbW5nntoVjluW3zMo++2MZP4CgDmPhTbajY/C/RLPWYGgvIIDG6P1AViB+ldDZ6NZWOqahqNvFtutRdGuHJzu2IFUfQAfqav45zRQAUUUUAFFFFABRRRQAUUU0tg9/wAiaAHUUUUAFGKKKACjFFFAHOeEfCo8NRX/AJkoubi9vJLmW5I+d9xyoJ9s8V0eKKKAAjNea+LQNI+OPg/VT8sWo21zp0rdOQPMT9eK9KrG8Q+F9O8THTjqSMW068S8gZGwQ69Pw9RQBs0UAYGBRQAUUUUAFFFFABRRRQAUUUUAFFFFAH//2Q==",
                                                        "photo": null
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    "headquarter": null,
                                    "location": {
                                        "id": 274,
                                        "name": " "
                                    },
                                    "userCreator": {
                                        "id": 446,
                                        "profesion": " ",
                                        "position": " ",
                                        "email": " ",
                                        "person": {
                                            "name": " ",
                                            "secondName": " ",
                                            "lastName": " ",
                                            "secondLastName": " ",
                                            "cardId": " ",
                                            "phone": " ",
                                            "firm": "{}"
                                        }
                                    },
                                    "municipality": null
                                }
                            ))
                        }}>
                            {loadingFullDataEquipment ? <LoadingOutlined /> : "Formato vacio"}
                        </button> */}
            {/*  <button className='button' onClick={() => setPdf('all')}>Descargar </button> */}
          </div>
        )}

        {(fullDataEquipment || partsComputersEquipment) && (
          <PDFViewer className="pdf">
            <Document>{content}</Document>
          </PDFViewer>
        )}
        {equipAndReportPDF && (
          <div>
            <PDFViewer className="pdf">
              <Document>{content}</Document>
            </PDFViewer>
            {equipAndReportPDF.caseReport &&
              equipAndReportPDF.caseReport.map((d, i) => (
                <embed key={i} className="pdf" src={d.pdf}></embed>
              ))}
          </div>
        )}
      </Modal>
    );
  };

  const onDelete = () => {
    if (window.confirm("¿Seguro deseas eliminar este equipo?")) {
      const dataDelete = {
        id: data.id,
      };
      dispatch(EquipmentActions.deleteEquipment(dataDelete));
    }
  };

  let brand, serie, modell, licensePlate;

  if (data.networkingAndCommunicationsEquipment) {
    brand = data.networkingAndCommunicationsEquipment.brand;
    serie = data.networkingAndCommunicationsEquipment.serie;
    modell = data.networkingAndCommunicationsEquipment.modell;
    licensePlate = data.licensePlate;
  } else if (data.peripheralsAndAccessoriesEquipment) {
    brand = data.peripheralsAndAccessoriesEquipment.brand;
    serie = data.peripheralsAndAccessoriesEquipment.serie;
    modell = data.peripheralsAndAccessoriesEquipment.modell;
    licensePlate = data.licensePlate;
  } else if (data.computersEquipment) {
    if (data.computersEquipment.brandCPU) {
      brand = data.computersEquipment.brandCPU;
      serie = data.computersEquipment.serieCPU;
      modell = data.computersEquipment.modellCPU;
      licensePlate = data.computersEquipment.licensePlateCPU;
    } else if (data.computersEquipment.brandAllInOne) {
      brand = data.computersEquipment.brandAllInOne;
      serie = data.computersEquipment.serieAllInOne;
      modell = data.computersEquipment.modellAllInOne;
      licensePlate = data.computersEquipment.licensePlateAllInOne;
    } else if (data.computersEquipment.brandLaptop) {
      brand = data.computersEquipment.brandLaptop;
      serie = data.computersEquipment.serieLaptop;
      modell = data.computersEquipment.modellLaptop;
      licensePlate = data.computersEquipment.licensePlateLaptop;
    }
  }

  // Obtén una referencia a todos los elementos
  const elements = document.querySelectorAll(".dataDiv");

  elements.forEach((element) => {
    // Obtén una referencia al elemento padre
    const parent = element.parentElement;

    // Calcula el tamaño de la fuente como un porcentaje del ancho del elemento padre
    const fontSize = parent.offsetWidth * 0.014; // 1.4% del ancho del padre

    // Establece el tamaño de la fuente del elemento
    element.style.fontSize = `${fontSize}px`;
  });

  return (
    <div className="EquipmentSystem" style={{ width: width, height: height }}>
      {image ? (
        <img className="equipmentImage" src={image.image} alt="img" />
      ) : (
        <div style={{ marginRight: "5vw" }}></div>
      )}
      <div
        className="dataDiv"
        onClick={() => {
          if (extraOnClick) {
            extraOnClick(data);
          } else {
            setVisibleModal(true);
          }
        }}
      >
        <div>
          <p className="pFontData name">{data.name}</p>
        </div>
        <div>
          <p className="pFontData">{brand}</p>
        </div>
        <div>
          <p className="pFontData">{modell}</p>
        </div>
        <div>
          <p className="pFontData">{serie}</p>
        </div>
        <div>
          <p className="pFontData">{licensePlate}</p>
        </div>
        <div>
          <p className="pFontData">{data.location.name}</p>
        </div>
        {data.state === "Funcional" ? (
          <div className="status">
            <p className="pFontStatus">Funcional</p>
          </div>
        ) : data.state === "No funcional" ? (
          <div className="status1">
            <p className="pFontStatus">{data.state}</p>
          </div>
        ) : (
          data.state === "Dado de baja" && (
            <div className="status2">
              <p className="pFontStatus">Baja</p>
            </div>
          )
        )}
      </div>
      {roleUser.id !== 36 && data.userCreator.id === idUser && (
        <div className="deleteDiv">
          <CloseOutlined className="deleteIcon" onClick={() => onDelete()} />
        </div>
      )}
      <ModalEquip />
    </div>
  );
};
